"use client";

import Link from "next/link";
import { Button } from "@/app/components/ui/button";

export function ExploreServicesButton() {
  const handleScroll = () => {
    const element = document.getElementById("end-to-end-solutions");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Link href="#end-to-end-solutions" className="w-full sm:w-auto">
      <Button
        variant="outline"
        size="lg"
        onClick={handleScroll}
        className="w-full border-[rgb(var(--color-neon-blue)_/_0.2)] hover:border-[rgb(var(--color-neon-blue)_/_0.4)] bg-transparent text-[rgb(var(--color-neon-blue))] hover:bg-[rgb(var(--color-neon-blue)_/_0.1)] px-8 py-6 text-lg font-medium flex items-center justify-center gap-2 shadow-[0_0_10px_rgba(var(--color-neon-blue),0.3)]"
      >
        <span>Explore Our Services</span>
        <span className="inline-block animate-nudge-x">→</span>
      </Button>
    </Link>
  );
}
